import React from "react";
import DrawerModal, {
  DrawerModalLoaction,
} from "../../../new_components/common/drawer_modal";
import { RoleModel } from "../../content_panel/infrastructure/models/user_model";


interface DeleteRoleModalProps {
  isOpen: boolean;
  onClose: () => void;
  user: any;
  selectedRoles: string[]; // roles selected in filters
  roles: RoleModel[]; // all roles
  rolesToDelete: string[]; // currently selected roles for deletion
  onRoleToggle: (roleId: string) => void;
  onConfirmDelete: () => void;
  loading: boolean;
}

const DeleteRoleModal: React.FC<DeleteRoleModalProps> = ({
  isOpen,
  onClose,
  user,
  selectedRoles,
roles,
  rolesToDelete,
  onRoleToggle,
  onConfirmDelete,
  loading,
}) => {
  if (!isOpen || !user) return null;

  return (
    <DrawerModal
      id="user_roles_delete_role_drawer"
      location={DrawerModalLoaction.right}
      onClose={onClose}
      show={isOpen}
      title={`Delete Roles for ${user.first_name} ${user.last_name}`}
    >
      <div className="p-6 space-y-6">
        <p className="text-gray-700 text-lg font-medium">
          Do you want to delete roles for{" "}
          <span className="font-semibold">
            {user.first_name} {user.last_name}
          </span>
          ?
        </p>
        <p className="text-sm text-gray-600">
          Uncheck any roles you don’t want to delete:
        </p>

        <div className="space-y-3">
          {selectedRoles.map((roleId:any) => {
            const role = roles.find((r:RoleModel) => r.id === roleId);
            if (!role) return null;

            return (
              <div key={roleId} className="flex items-center space-x-3">
                <input
                  type="checkbox"
                  id={`delete-role-${roleId}`}
                  checked={rolesToDelete.includes(roleId)}
                  onChange={() => onRoleToggle(roleId)}
                  className="w-4 h-4 text-red-600 rounded border-gray-300 focus:ring-red-500"
                />
                <label
                  htmlFor={`delete-role-${roleId}`}
                  className="text-sm text-gray-700 cursor-pointer"
                >
                  {role.name}
                </label>
              </div>
            );
          })}
        </div>

        {rolesToDelete.length === 0 && (
          <div className="text-sm text-orange-600 bg-orange-50 p-3 rounded">
            Please select at least one role to delete.
          </div>
        )}

        <div className="flex space-x-3 pt-4">
          <button
            id="user_roles_delete_role_cancel_btn"
            onClick={onClose}
            className="flex-1 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            id="user_roles_delete_role_confirm_btn"
            onClick={onConfirmDelete}
            disabled={rolesToDelete.length === 0 || loading}
            className="flex-1 px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 disabled:opacity-50"
          >
            {loading ? "Deleting..." : "Confirm Delete"}
          </button>
        </div>
      </div>
    </DrawerModal>
  );
};

export default DeleteRoleModal;